
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";



const LoginAdmin = () => {

    // State for Login ID text Box 
    const [userLogin, setUserLogin] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();



    const handleLogin = async (event) => {
        event.preventDefault();

          // Hardcoded credentials
          const validLogin = "9999999999";
          const validPassword = "12345";
  
          if (userLogin === validLogin && password === validPassword) {
              // Navigate to /memberData if login is successful
              navigate("/memberData");
          } else {
              // Show an error message for incorrect credentials
              setErrorMessage("Invalid Login Name or Password.");
          }

    };


    return (
        <>
        <header>
                <div className="logo1">
                    <img src="images/mumbai fc.jpg" alt="mumbai fc logo" />
                </div>
                <div className="logo2">
                    <img src="images/insol-india-logo.jpg" alt="insol india logo" />
                </div>
            </header>
            <section className="secbg">
                <div className="loginbox">
                    <div>
                        <div className="logintitle">
                        Admin Login
                        </div>
                        <form className="login_form">
                            <div className="row_input">
                                <span className="lbl1">Enter Your Login Name</span>
                                <input type="text" 
                                autoFocus value={userLogin} 
                                maxLength={10} 
                                onChange={(e) => setUserLogin(e.target.value)}                                 
                                className="txt1" 
                                placeholder="Login Name" 
                                autoComplete="off"
                                />
                            </div>
                            <div className="row_input">
                            <span className="lbl1">Password</span>
                                <input type="password" 
                                value={password} 
                                maxLength={10} 
                                onChange={(e) => setPassword(e.target.value)} 
                                className="txt1"  
                                placeholder="Password" />
                            </div>
                            <div className="text-center p-2 mb-3">
                                <button className="btnlogin" onClick={handleLogin}>Login Now</button>
                            </div>
                            {errorMessage && <div className="text-danger">{errorMessage}</div>}
                        </form>
                    </div>
            
                </div>
            </section>            
            
        </>
    )
};
export default LoginAdmin;